import SoftBadge from "@/components/atoms/SoftBadge";
import { FC } from "react";

/** Suivi du déploiement (spec 2026-10-08, § 7) : qui n'a pas encore rempli sa semaine. */
const AvailabilityStatusBadge: FC<{ setAt: string | null | undefined }> = ({ setAt }) =>
  setAt ? (
    <SoftBadge bg="success" className="my-2">
      Dispos renseignées
    </SoftBadge>
  ) : (
    <SoftBadge bg="warning" className="my-2">
      Dispos non renseignées
    </SoftBadge>
  );

export default AvailabilityStatusBadge;
